module.exports = __webpack_public_path__ + "img/product.609eb1cc.jpg";